module.exports = __webpack_public_path__ + "static/media/plusIcon.3e0a18f3.svg";